// extracted by mini-css-extract-plugin
module.exports = {"label":"DownLabelItem_label__HN43n","label1":"DownLabelItem_label1__mClUA","label2":"DownLabelItem_label2__Nugbh"};